"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _DialogHeader = _interopRequireDefault(require("./DialogHeader"));

var _DialogBody = _interopRequireDefault(require("./DialogBody"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  header: {},
  body: {}
}));

const Dialog = (_ref) => {
  let children = _ref.children,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 0 : _ref$padding,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "padding"]);

  const classes = useStyles();
  return _react.default.createElement("section", {
    className: classes.root
  }, _react.default.createElement(_DialogHeader.default, props), _react.default.createElement(_DialogBody.default, {
    padding: padding
  }, children));
};

Dialog.propTypes = process.env.NODE_ENV !== "production" ? {
  title: _propTypes.default.string,
  padding: _propTypes.default.number,
  search: _propTypes.default.shape({
    placeholder: _propTypes.default.string,
    q: _propTypes.default.string,
    onChange: _propTypes.default.func
  }),
  onClose: _propTypes.default.func
} : {};
var _default = Dialog;
exports.default = _default;
module.exports = exports.default;